<template>
  <div class="mybooking-online-cost">
    <div>
      <div class="quotation_info mb-2">
        <div class="mr-2">Quotation No.</div>
        <div class="">|</div>
        <div class="ml-2">
          {{
            request_quotation.quotation
              ? request_quotation.quotation.toString().startsWith("WR1")
                ? request_quotation.quotation
                : ""
              : ""
          }}
        </div>
      </div>

      <div v-if="costs">
        <vue-perfect-scrollbar
          :settings="{
            maxScrollbarLength: 120,
            suppressScrollX: true,
          }"
          style="height: 48vh"
          class="scrollable-container scroll-area"
        >
          <validation-observer ref="quotationRules">
            <div
              v-if="
                request_quotation
                  ? !['4', '5', '6'].includes(request_quotation.service_type)
                  : !['4', '5', '6'].includes(serviceType)
              "
            ></div>
            <b-card class="b-card-bg" v-for="c in costs" :key="c.id">
              <b-row>
                <b-col cols="2" class="pl-0">
                  <span style="padding-left: 1rem">
                    Payer <font class="red">*</font></span
                  ></b-col
                >
                <b-col cols="2" class="pl-0"><span>Description</span></b-col>
                <b-col cols="2" class="pl-0"
                  >Unit <font class="red">*</font></b-col
                >
                <b-col cols="1" class="pl-0"
                  >Unit Price <font class="red">*</font></b-col
                >
                <b-col cols="1" class="pl-0"
                  >Quantity <font class="red">*</font></b-col
                >
                <b-col cols="1" class="pl-0"
                  >Currency <font class="red">*</font></b-col
                >
                <b-col cols="1" class="pl-0"
                  >Vat<font class="red">*</font></b-col
                >
                <b-col cols="1" class="pl-0"
                  >Amount <font class="red">*</font></b-col
                >
                <b-col cols="1" class="pl-0">Note</b-col>
              </b-row>
              <b-row v-for="(i, index) in c.detail" :key="index">
                <!--  Payable acc  -->
                <b-col cols="2" class="pl-0">
                  <validation-provider
                    #default="{ errors }"
                    rules="required"
                    class="float-left w-100"
                    style="padding-left: 1rem; display: flex"
                  >
                    <b-form-group class="w-100">
                      <!-- <Select2
                        :class="[
                          errors.length > 0 ? 'is-invalid' : null,
                          readonly == true ? 'remove' : '',
                        ]"
                        :disabled="readonly"
                        placeholder="Payable acc"
                        :options="companyItems"
                        v-model="i.payableAcc"
                        :state="errors.length > 0 ? false : null"
                        :searchable="true"
                        :show-labels="false"
                      /> -->
                      <Select4
                        v-model="i.payableAcc"
                        :classProp="[
                          errors.length > 0 ? 'is-invalid' : null,
                          readonly == true ? 'remove' : '',
                        ]"
                        placeholder="Select Company"
                        :options="{
                          isSearch: true,
                          width: '900px',
                          value: 'name',
                          label: 'text',
                          all: true,
                          data: companyItems,
                          fields: [
                            { field: 'code', label: 'Tax Code' },

                            { field: 'name', label: 'Name' },
                            {
                              field: 'acronym',
                              label: 'Acronym',
                            },
                          ],
                        }"
                      />

                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <!-- Description -->
                <b-col cols="2" class="pl-0">
                  <validation-provider #default="{ errors }" rules="required">
                    <b-form-group>
                      <Select2
                        :class="[
                          errors.length > 0 ? 'is-invalid' : null,
                          readonly == true ? 'remove' : '',
                        ]"
                        :disabled="readonly"
                        placeholder="POL"
                        v-model="i.fee_type"
                        @select="
                          ({ text, is_tms }) => {
                            i.fee_type_name = text;
                            i.is_tms = is_tms;
                          }
                        "
                        :options="fee_types"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <!-- Unit * -->
                <b-col cols="2" class="pl-0">
                  <validation-provider #default="{ errors }" rules="">
                    <b-form-group>
                      <!-- <Select2
                        :class="[
                          errors.length > 0 ? 'is-invalid' : null,
                          readonly == true ? 'remove' : '',
                        ]"
                        :disabled="readonly"
                        placeholder="POL"
                        v-model="i.unit"
                        :options="unit_types"
                      /> -->
                      <b-form-input
                        type="text"
                        :state="errors.length > 0 ? false : null"
                        :disabled="readonly"
                        v-model="i.unit"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <!-- Unit Price  -->
                <b-col cols="1" class="pl-0">
                  <validation-provider
                    name="Unit Price"
                    #default="{ errors }"
                    rules="required"
                  >
                    <b-form-group>
                      <b-form-input
                        type="text"
                        :formatter="formatter"
                        :state="errors.length > 0 ? false : null"
                        :disabled="readonly"
                        v-b-tooltip.hover
                        :title="i.unit_price"
                        v-model="i.unit_price"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <!-- Quantity  -->
                <b-col cols="1" class="pl-0">
                  <validation-provider
                    name="Quantity"
                    #default="{ errors }"
                    rules="required"
                  >
                    <b-form-group>
                      <b-form-input
                        type="number"
                        :state="errors.length > 0 ? false : null"
                        :disabled="readonly"
                        v-model="i.qty"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <!-- Currency -->
                <b-col cols="1" class="pl-0">
                  <validation-provider #default="{ errors }" rules="required">
                    <b-form-group>
                      <Select2
                        :class="[
                          errors.length > 0 ? 'is-invalid' : null,
                          readonly == true ? 'remove' : '',
                        ]"
                        :disabled="readonly"
                        v-model="i.currency"
                        :options="currencies"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <!-- vat  -->
                <b-col cols="1" class="pl-0">
                  <validation-provider
                    name="Amount"
                    #default="{ errors }"
                    rules="required"
                  >
                    <b-form-group>
                      <b-form-input
                        type="text"
                        :state="errors.length > 0 ? false : null"
                        :disabled="readonly"
                        v-model="i.vat"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <!-- payment  -->
                <b-col cols="12" lg="1" class="pl-0">
                  <validation-provider #default="{ errors }" rules="required">
                    <b-form-group>
                      <b-form-input
                        :state="errors.length > 0 ? false : null"
                        :disabled="true"
                        :value="
                          (
                            i.qty * i.unit_price +
                            (i.vat / 100) * i.qty * i.unit_price
                          ).toLocaleString()
                        "
                      />
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <!-- note -->
                <b-col cols="1" class="pl-0">
                  <validation-provider #default="{ errors }" rules="">
                    <b-form-group>
                      <b-form-input
                        :state="errors.length > 0 ? false : null"
                        :disabled="readonly"
                        v-model="i.notes"
                      />

                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col cols="6" lg="2">
                  <b-row>
                    <div class="custom_check_quote">
                      <div class="flex items-center">
                        <input
                          :disabled="readonly"
                          type="radio"
                          class="custom-checkbox-new"
                          value="DEBT"
                          v-model="i.payment"
                          :checked="i.payment === 'DEBT'"
                        />

                        <div class="margin-left">Debit</div>
                      </div>

                      <div class="flex items-center">
                        <input
                          :disabled="readonly"
                          v-model="i.payment"
                          type="radio"
                          value="BEHALF"
                          class="custom-checkbox-new"
                          :checked="i.payment === 'BEHALF'"
                        />
                        <div class="margin-left">Credit</div>
                      </div>
                    </div>
                    <div class="custom_list_icon">
                      <div
                        class="cursor-pointer"
                        v-if="!readonly"
                        @click="
                          () => {
                            var idRandom = Math.floor(
                              Math.random() * Math.pow(10, 15)
                            );
                            c.detail.push({
                              ...c.detail[0],
                            });
                          }
                        "
                      >
                        <b-img width="30px" :src="iconAdd" alt="logo" />
                      </div>
                      <div
                        v-if="!readonly"
                        class="cursor-pointer"
                        @click="c.detail.splice(index, 1)"
                      >
                        <b-img width="30px" :src="remove" alt="logo" />
                      </div>
                    </div>
                  </b-row>
                  <small
                    class="text-danger custom-danger"
                    v-if="i.payment == ''"
                    >Please select at least one checkbox.</small
                  >
                </b-col>
              </b-row>
            </b-card>
            <div
              class="pt-1"
              v-if="
                /*dynamicService && */ costs.length < default_costs.length &&
                !readonly
              "
            >
              <b-row>
                <b-col cols="12">
                  <h5 class="float-left">
                    <feather-icon icon="PlusIcon" /> Add Service
                  </h5>
                  <div class="float-left">
                    <b-dropdown
                      variant="link"
                      toggle-class="text-decoration-none p-0 ml-1 text-primary"
                      no-caret
                    >
                      <template v-slot:button-content
                        ><feather-icon
                          icon="MoreVerticalIcon"
                          size="16"
                          class="text-primary align-middle mr-25"
                      /></template>
                      <b-dropdown-item
                        @click="costs.push(i)"
                        :key="i.id"
                        v-for="i in default_costs.filter(
                          (i) => costs.filter((j) => j.id === i.id).length == 0
                        )"
                      >
                        <feather-icon icon="FolderIcon" class="mr-50" />
                        <span>{{ i.name }}</span>
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                </b-col>
              </b-row>
            </div>
            <b-row>
              <b-col cols="8"></b-col>
              <b-col cols="3" style="padding-bottom: 40px">
                <div class="mb-1 p-1">
                  <b-row>
                    <b-col cols="7"
                      ><h3 class="text-warning-blue mb-0">Subtotal</h3></b-col
                    >
                    <b-col cols="5">
                      <b-row v-for="c in currencies" :key="c.id">
                        <b-col cols="12" v-if="getTotal(c.id) > 0">
                          <b-row>
                            <b-col cols="6"
                              ><h3 class="mb-0">
                                {{
                                  c.id == "VND"
                                    ? $Utils.formatMooney(
                                        getTotal(c.id),
                                        "vi-VN"
                                      )
                                    : $Utils.formatMooney(
                                        getTotal(c.id),
                                        "en-US"
                                      )
                                }}
                              </h3></b-col
                            >
                            <b-col cols="6"
                              ><h3 class="mb-0">{{ c.id }}</h3></b-col
                            >
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="7"
                      ><h3 class="text-warning-blue mb-0">Vat</h3></b-col
                    >
                    <b-col cols="5">
                      <b-row v-for="c in currencies" :key="c.id">
                        <b-col cols="12" v-if="getTotal(c.id) > 0">
                          <b-row>
                            <b-col cols="6"
                              ><h3 class="mb-0">
                                {{
                                  c.id == "VND"
                                    ? $Utils.formatMooney(
                                        getTotalVAT(c.id),
                                        "vi-VN"
                                      )
                                    : $Utils.formatMooney(
                                        getTotalVAT(c.id),
                                        "en-US"
                                      )
                                }}
                              </h3></b-col
                            >
                            <b-col cols="6"
                              ><h3 class="mb-0">{{ c.id }}</h3></b-col
                            >
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="7"
                      ><h3 class="text-warning-blue mb-0">
                        Grand Total
                      </h3></b-col
                    >
                    <b-col cols="5">
                      <b-row v-for="c in currencies" :key="c.id">
                        <b-col cols="12" v-if="getTotal(c.id) > 0">
                          <b-row>
                            <b-col cols="6"
                              ><h3 class="mb-0">
                                {{
                                  c.id == "VND"
                                    ? $Utils.formatMooney(
                                        getTotalGrandTotal(c.id),
                                        "vi-VN"
                                      )
                                    : $Utils.formatMooney(
                                        getTotalGrandTotal(c.id),
                                        "en-US"
                                      )
                                }}
                              </h3></b-col
                            >
                            <b-col cols="6"
                              ><h3 class="mb-0">{{ c.id }}</h3></b-col
                            >
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
            </b-row>
          </validation-observer>
        </vue-perfect-scrollbar>
      </div>
    </div>
    <div v-if="request_quotation != null">
      <div class="custom-right">
        <a @click="generateReport" class="btn round btn-primary pl-2 pr-2 mr-1"
          ><feather-icon icon="SendIcon" /> Preview quotation (PDF)</a
        >

        <a
          @click="updateCostsInfo"
          type="submit"
          class="btn round btn-success pl-2 pr-2 mr-1"
          ><feather-icon icon="CheckSquareIcon" /> Update Cost
        </a>
      </div>
    </div>
    <vue-html2pdf
      :show-layout="false"
      ref="pdfCost"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="1100"
      :pdf-quality="1"
      :manual-pagination="false"
      pdf-format="a3"
      @progress="onProgress"
      pdf-orientation="portrait"
      pdf-content-width="100%"
      :html-to-pdf-options="{
        margin: 15,
        jsPDF: { orientation: 'portrait', format: 'a3', unit: 'mm' },
      }"
    >
      <section slot="pdf-content">
        <print-cost
          v-if="request_quotation != null"
          :booking="booking"
          :costs_info="{ costs: costs }"
          :vat="vat"
          :pay="payments"
          :companyItems="companyItems"
          :fee_types="fee_types"
          :unit_types="unit_types"
          :currencies="currencies"
          :request_quotation="request_quotation"
          :service_types="service_types"
          :locations="locations"
        />
      </section>
    </vue-html2pdf>
  </div>
</template>
<style>
.is-invalid .select2-selection--single {
  border: 1px solid #ea5455;
}
.is-invalid .select2-selection--single::before {
  content: "";
  position: absolute;
  right: 14px;
  top: 0;
  bottom: 0;
  width: 14px;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23ea5455' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23ea5455' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
}
.red {
  color: red;
}
.vue-dropzone > .dz-preview .dz-details {
  background-color: #2b938c;
  border-radius: 15px;
}
.table-print {
  border-collapse: collapse !important;
  width: 100%;
  border: 1px solid #333 !important;
}
.table-print td {
  text-align: left;
}
.table-print th {
  text-align: center;
}
.table-print td,
.table-print th {
  border-bottom: 1px solid #333 !important;
  border-right: 1px solid #333 !important;
  padding: 4px 6px;
}
.table-print th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #2b938c;
  color: white;
}
.modal-footer .btn {
  width: auto !important;
}
</style>
<script>
import {
  BAvatar,
  BForm,
  BFormTextarea,
  BImg,
  BDropdown,
  BDropdownItem,
  BButton,
  BFormInput,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BInputGroupPrepend,
  BFormDatepicker,
  BRow,
  BCol,
  BTable,
  BCard,
  BCardText,
} from "bootstrap-vue";
import Select2 from "v-select2-component";
import useJwt from "@/auth/jwt/useJwt";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

import { $ctx } from "@themeConfig";
import VueHtml2pdf from "vue-html2pdf";
import Vue from "vue";
import PrintCost from "./PrintCost.vue";
import NewShipmentOnFast from "./NewShipmentOnFast.vue";
import NewShipmentOnTms from "./NewShipmentOnTms.vue";
import NProgress from "nprogress";
import { mapState, mapActions } from "vuex";
import { isJson } from '@core/utils/utils';
const default_costs = [];
const cost_info = [
  {
    id: "pol",
    name: "Service at POL",
    detail: [
      {
        fee_type: 8,
        companyItems: 4,
        unit: 7,
        unit_price: 0,
        qty: 1,
        currency: "USD",
        notes: "",
        checked: true,
      },
    ],
  },
  {
    id: "local_pol",
    name: "Local charges at POL",
    detail: [
      {
        fee_type: 8,
        companyItems: 4,
        unit: 7,
        unit_price: 0,
        qty: 1,
        currency: "USD",
        notes: "",
        checked: true,
      },
    ],
  },
  {
    id: "freight",
    name: "Freight",
    detail: [
      {
        fee_type: 8,
        companyItems: 4,
        unit: 7,
        unit_price: 0,
        qty: 1,
        currency: "USD",
        notes: "",
        checked: true,
      },
    ],
  },
  {
    id: "local_pod",
    name: "Local charges at POD",
    detail: [
      {
        fee_type: 8,
        companyItems: 4,
        unit: 7,
        unit_price: 0,
        qty: 1,
        currency: "USD",
        notes: "",
        checked: true,
      },
    ],
  },
  {
    id: "pod",
    name: "Service at POD",
    detail: [
      {
        fee_type: 8,
        companyItems: 4,
        unit: 7,
        unit_price: 0,
        qty: 1,
        currency: "USD",
        notes: "",
        checked: true,
      },
    ],
  },
];
const default_com = [
  {
    id: "commission",
    name: "Commission",
    detail: [
      {
        payableAcc: -1,
        fee_type: 8,
        unit: 7,
        unit_price: 0,
        qty: 1,
        currency: "USD",
        notes: "",
        checked: true,
        vat: 0,
        payment: "DEBT",
      },
    ],
  },
];
export default {
  props: {
    readonly: { default: false, type: Boolean },
    view_quotation: { default: null },
    request_quotation: { default: null },
    isCustomer: { default: null },
    booking: { default: null },
    costs_info: { default: null },
    step: { default: null },
    serviceType: { default: null },
    status: {
      default: false,
    },
  },
  components: {
    NewShipmentOnTms,
    NewShipmentOnFast,
    BAvatar,
    BForm,
    PrintCost,
    VuePerfectScrollbar,
    BImg,
    VueHtml2pdf,
    BDropdown,
    BDropdownItem,
    BButton,
    BFormTextarea,
    ValidationProvider,
    BCardText,
    ValidationObserver,
    BFormInput,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupPrepend,
    BFormDatepicker,
    BRow,
    BCol,
    BTable,
    BCard,
    BCardText,
    Select2,
    vueDropzone: vue2Dropzone,
    FeatherIcon,
  },
  data() {
    return {
      valueProgress: 0,
      appLogoImage: require("@/assets/images/logo/logo.svg"),
      userData: JSON.parse(localStorage.getItem("userData")),
      currentItem: {},
      // companyItems:null,
      payments: [
        { id: "DEBT", text: "DEBT" },
        { id: "BEHALF", text: "BEHALF" },
      ],
      vat: 10,
      currencies: [
        { id: "VND", text: "VNĐ" },
        { id: "USD", text: "USD" },
      ],
      quotation: {
        shipping_line: null,
        valid_from: new Date(),
        notes:
          "The price does not include VAT, insurance,...\n- We hope that above rates and conditions shall meet your requirement.\n- Required export license & provide full docs for customs clearance.\n- Meanwhile, please feel free to contact us at if you have any questions.",
      },
      tempQuotation:
        JSON.parse(JSON.stringify(this.costs_info)) ||
        JSON.parse(JSON.stringify(this.booking)),

      default_costs: default_costs,
      costs: JSON.parse(JSON.stringify(default_costs)),
      // tạo dữ liễu để truyền sang preview
      cost_info: cost_info,
      cost_info: JSON.parse(JSON.stringify(cost_info)),
      chats: null,
      tempCosts_info: null,
      tempCosts: null,
      isDraft: false,

      dynamicService: false,
      message: null,
      dropzoneOptions: {
        url: $ctx.API_URL + "uploadFile",
        addRemoveLinks: true,

        createImageThumbnails: false,
        acceptedFiles: this.$Utils.CONSTANTS.TYPE_UPLOAD.type,
        destroyDropzone: true,
        maxFilesize: this.$Utils.CONSTANTS.TYPE_UPLOAD.size,
        maxFiles: this.$Utils.CONSTANTS.TYPE_UPLOAD.max,
        headers: { apiKey: localStorage.getItem("accessToken") },
      },
    };
  },
  watch: {
    valueProgress(val) {
      if (val == 100) NProgress.done();
    },
  },
  // thành add
  computed: {
    ...mapState("masterData", [
      "companyItems",
      "sales",
      "cont_types",
      "fee_types",
      "shipping_lines",
      "service_types",
      "locations",
    ]),
    unit_types() {
      return this.cont_types.filter((i) => i.group == "Unit");
    },
    company_list() {
      return this.companyItems;
    },
  },

  mounted() {
    this.$root.$on("bv::modal::shown", (bvEvent, modalId) => {
      document.getElementsByClassName("modal-content").forEach(function (v) {
        v.removeAttribute("tabindex");
      });
    });
    this.loadDataInput();
  },

  // thanh add
  methods: {
    ...mapActions("masterData", ["fetchCompany", "fetchSaler"]),
    loadDataInput() {
      useJwt
        .get("wr1?objectType=CostInfo", {
          params: { search: { bookingId: this.request_quotation.bookingID } },
        })
        .then((response) => {
          
          

          if (isJson(response?.data?.result?.[0]?.FAST)) {
            const costInfo = JSON.parse(response?.data?.result?.[0]?.FAST) || null;
            // @todo open when UI done
            // const costInfo = [
            //   {
            //     HAWBNO: "SGNHKG23063021",
            //     PartnerID: "CS001241",
            //     Quantity: 1.0,
            //     QUnit: "CBM",
            //     UnitPrice: 10.0,
            //     CurrencyConvertRate: "USD",
            //     VAT: 0.0,
            //     TotalValue: 10.0,
            //     ExtRate: 10.0,
            //     ExtRateVND: 20000.0,
            //     ExtVND: 23660.0,
            //     ExtVNDP: 0.0,
            //     Amount: 0.0,
            //     Notes: "RD",
            //     Dpt: false,
            //     Obh: false,
            //     KBck: true,
            //     NoInv: false,
            //     Paid: false,
            //     SortInv: false,
            //     SortDes: "B_REFUND",
            //     FieldKey: "WF07(1318985)",
            //     DataInput: "2",
            //     OBHLink: false,
            //     FixedCost: false,
            //     CC: false,
            //     TT: false,
            //     IDKeyIndex: 1318985.0,
            //     IDKeyShipmentDT: 645140.0,
            //     GWHeavyW: false,
            //     Gainloss: false,
            //     USDEx: 1.0,
            //     ShipmentDate: "2023-06-12T00:00:00+07:00",
            //     AutoInput: false,
            //     UserInputRCD: "WF07",
            //     Advanced: false,
            //     RemoteCharges: false,
            //     USDExPM: 1.0,
            //     ISUPDATE: false,
            //   },
            //   {
            //     HAWBNO: "SGNHKG23063021",
            //     PartnerID: "CS001794",
            //     Quantity: 1.0,
            //     QUnit: "CBM",
            //     UnitPrice: 28.0,
            //     CurrencyConvertRate: "USD",
            //     VAT: 0.0,
            //     TotalValue: 28.0,
            //     ExtRate: 28.0,
            //     ExtRateVND: 20000.0,
            //     ExtVND: 23660.0,
            //     ExtVNDP: 0.0,
            //     Amount: 0.0,
            //     Notes: "CS",
            //     Dpt: false,
            //     Obh: false,
            //     KBck: true,
            //     NoInv: false,
            //     Paid: false,
            //     SortInv: false,
            //     SortDes: "B_COMMISSIONCUSTOMER",
            //     FieldKey: "WF07(1318986)",
            //     DataInput: "3",
            //     OBHLink: false,
            //     FixedCost: false,
            //     CC: false,
            //     TT: false,
            //     IDKeyIndex: 1318986.0,
            //     IDKeyShipmentDT: 645140.0,
            //     GWHeavyW: false,
            //     Gainloss: false,
            //     USDEx: 1.0,
            //     ShipmentDate: "2023-06-12T00:00:00+07:00",
            //     AutoInput: false,
            //     UserInputRCD: "WF07",
            //     Advanced: false,
            //     RemoteCharges: false,
            //     USDExPM: 1.0,
            //     ISUPDATE: false,
            //   },
            // ];
            var renderArray = [];

            costInfo.map((e) => {
              var obj = {};
              obj.payableAcc_fast_id = e.PartnerID;
              obj.payableAcc =
                this.companyItems.find(
                  (i) => i.fast_id.toLowerCase() == e.PartnerID.toLowerCase()
                )?.id || "";

              obj.unit = e.QUnit;
              obj.unit_price = this.$Utils.formatMooney(
                e.UnitPrice.toFixed(e.CurrencyConvertRate == "USD" ? 3 : 0),
                e.CurrencyConvertRate == "USD" ? "en-US" : "vi-VN"
              );
              obj.currency = e.CurrencyConvertRate;
              obj.notes = e.Notes;
              obj.qty = e.Quantity;
              obj.fee_type =
                this.fee_types.find((i) => i.code == e.SortDes)?.id || "";
              obj.checked = true;
              obj.vat = e.VAT || 0;
              obj.payment = "DEBT";
              renderArray = [...renderArray, obj];
            });

            this.costs = [
              {
                id: "commission",
                name: "Commission",
                detail: renderArray,
              },
            ];
          } else {
            this.costs = null;
          }
        });
    },
    formatter(value) {
      return value.toFixed(3);
    },
    loadChart() {
      if (this.quotation != null && this.quotation.id != null) {
        useJwt
          .get("wr1?objectType=Chats", {
            params: { search: { id: this.quotation.id } },
          })
          .then((response) => {
            this.chats =
              response.data.result == null
                ? null
                : response.data.result.reverse();
          });
      }
    },
    async sendChat(bvModalEvt) {
      bvModalEvt.preventDefault();
      var validate = await this.$refs.chatRules.validate().then((success) => {
        return success;
      });
      if (!validate) {
        return;
      }
      useJwt
        .put("wr1?objectType=SendChat", {
          id: this.request_quotation.id,
          message: this.message,
          date: new Date(),
          role: this.isCustomer ? "customers" : "wr1",
          fullName: this.userData.fullName,
        })
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Sent chat to WR1!",
              icon: "CheckSquareIcon",
              variant: "primary",
            },
          });
          this.loadChart();
          this.$refs.chatRules.reset();
          this.message = "";
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Send chat error!",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    },
    onProgress(val) {
      this.valueProgress = val;
    },
    async generateReport() {
      await NProgress.start();
      const doc = await this.$refs.pdfCost.generatePdf();
    },
    getTotal(currency) {
      var t = 0;
      this.costs.forEach((c) => {
        c.detail.forEach((i) => {
          if (i.checked && i.currency == currency) {
            if (currency == "USD") {
              t += i.qty * (i.unit_price + "").replace(/,/g, "");
            } else {
              t +=
                i.qty *
                (i.unit_price + "").replace(/\./g, "").replace(/,/g, "");
            }
          }
        });
      });
      return t;
    },
    getTotalGrandTotal(currency) {
      var t = 0;
      this.costs.forEach((c) => {
        c.detail.forEach((i) => {
          if (i.checked && i.currency == currency) {
            if (currency == "USD") {
              t +=
                i.qty * (i.unit_price + "").replace(/,/g, "") +
                i.qty *
                  (i.unit_price + "").replace(/,/g, "") *
                  (i.vat ? i.vat / 100 : "");
            } else {
              t +=
                i.qty *
                  (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") +
                i.qty *
                  (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") *
                  (i.vat ? i.vat / 100 : "");
            }
          }
        });
      });
      return t;
    },
    getTotalVAT(currency) {
      var t = 0;
      this.costs.forEach((c) => {
        c.detail.forEach((i) => {
          if (i.checked && i.currency == currency) {
            if (currency == "USD") {
              t +=
                i.qty *
                (i.unit_price + "").replace(/,/g, "") *
                (i.vat ? i.vat / 100 : "");
            } else {
              t +=
                i.qty *
                (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") *
                (i.vat ? i.vat / 100 : "");
            }
          }
        });
      });
      return t;
    },
    getVat(currency) {
      var va = 0;
      this.costs.forEach((c) => {
        c.detail.forEach((i) => {
          if (i.checked && i.currency == currency && i.vat > 0) {
            if (currency == "VND") {
              va +=
                (i.vat *
                  i.qty *
                  (i.unit_price + "").replace(/\./g, "").replace(/,/g, "")) /
                100;
            } else {
              va +=
                (i.vat * i.qty * (i.unit_price + "").replace(/,/g, "")) / 100;
            }
          }
        });
      });
      return va;
    },
    sub(currency) {
      var s = 0;
      this.costs.forEach((c) => {
        c.detail.forEach((i) => {
          if (i.checked && i.currency == currency && i.vat > 0) {
            if (currency == "VND") {
              s +=
                i.qty *
                  (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") +
                (i.vat *
                  i.qty *
                  (i.unit_price + "").replace(/\./g, "").replace(/,/g, "")) /
                  100;
            } else {
              s +=
                i.qty * (i.unit_price + "").replace(/,/g, "") +
                (i.vat * i.qty * (i.unit_price + "").replace(/,/g, "")) / 100;
            }
          }
        });
      });
      return s;
    },

    uploadSuccess: function (file, response) {
      response.result.isRequestFile = "0";
      response.result.bookingId = this.booking.id;
      response.result.size = `${file.size}`;
      if (file && response.message == "success!") {
        this.$store.dispatch("attachFile/upFile", response.result);
      }
    },
    removeFile(file, error, xhr) {
      const xhrJson = JSON.parse(file.xhr.response);
      const path = xhrJson.result.path;
      const bookingId = this.booking.id;

      this.$store.dispatch("attachFile/deleteFile", { bookingId, path });
    },

    async updateCostsInfo(ev) {
      ev.preventDefault();

      var costsNew = {};
      costsNew.id = this.request_quotation.id;

      useJwt
        .put("wr1?objectType=UpdateCostsInfo", costsNew)
        .then((response) => {
          this.loadDataInput();

          this.$swal({
            icon: "success",
            title: "Update successfully",
          });
          // this.$toast({
          //   component: ToastificationContent,
          //   props: {
          //     title: "Loaded successfully ",
          //     icon: "CheckSquareIcon",
          //     variant: "primary",
          //   },
          // });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Update error!",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    },
    updateBooking() {
      useJwt
        .put("wr1?objectType=AcceptBooking", this.booking)
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Accepted Booking success!",
              icon: "CheckSquareIcon",
              variant: "primary",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Accept Booking error!",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    },
    async handUpdatePricing(ev) {
      ev.preventDefault();
      useJwt
        .put("wr1?objectType=UpdateBookingInfo", this.booking)
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Update success!",
              icon: "CheckSquareIcon",
              variant: "primary",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Update error!",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    },
    async handBooking(ev) {
      ev.preventDefault();
      useJwt
        .put("wr1?objectType=CustomerBooking", this.booking)
        .then((response) => {
          this.$emit("CustomerBookingEvent");

          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Booking success!",
              icon: "CheckSquareIcon",
              variant: "primary",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Booking error!",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    },
    async handCancelBooking(bvModalEvt) {
      bvModalEvt.preventDefault();
      var validate = await this.$refs.cancelRules.validate().then((success) => {
        return success;
      });
      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("notifyFormError"),
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }
      useJwt
        .put("wr1?objectType=CancelBooking", {
          id: this.request_quotation.id,
          cancel_reason: this.booking.cancel_reason,
        })
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Booking Cancelled success!",
              icon: "CheckSquareIcon",
              variant: "primary",
            },
          });
          this.$bvModal.hide("cancel-booking");
          this.$emit("CancelBookingEvent");
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Booking Cancel error!",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    },
    async handSend() {
      var validate = await this.$refs.quotationRules
        .validate()
        .then((success) => {
          return success;
        });
      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("notifyFormError"),
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }
      let t = 0;
      this.currencies.forEach((e) => {
        t += this.getTotal(e.id);
        // t += this.getVal(e.id);
      });
      if (t == 0 || Number.isNaN(t)) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Total = 0, please enter at least one fee!",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }
      this.$bvModal.show("request-an-update-msg");
    },
    async handRequestAnUpdate(bvModalEvt) {
      bvModalEvt.preventDefault();
      var validate = await this.$refs.reqanupdateRules
        .validate()
        .then((success) => {
          return success;
        });
      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("notifyFormError"),
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }
      if (this.status == 9 || (this.status == 8 && !this.isCustomer)) {
        useJwt
          .put("wr1?objectType=SendChat", {
            id: this.request_quotation.id,
            message: this.message,
            date: new Date(),
            role: this.isCustomer ? "customers" : "wr1",
            fullName: this.userData.fullName,
          })
          .then((response) => {
            if (this.status == 9 || (this.status == 8 && !this.isCustomer)) {
              this.loadChart();
              this.$emit("RequestAnUpdateEvent");
              this.$bvModal.hide("request-an-update-msg");
              this.message = "";
              this.handUpdatePricing(bvModalEvt);
              return;
            }
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Send Request An Update error!",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          });
      } else {
        useJwt
          .put("wr1?objectType=RequestAnUpdate", {
            id: this.request_quotation.id,
            message: this.message,
            date: new Date(),
            type: "customer_update_notes",
            role: this.isCustomer ? "customers" : "wr1",
            fullName: this.userData.fullName,
          })
          .then((response) => {
            if (
              this.status == 62 ||
              this.status == 21 ||
              this.status == 4 ||
              (this.status == 2 && !this.isCustomer)
            ) {
              this.loadChart();
              this.$emit("RequestAnUpdateEvent");
              this.$bvModal.hide("request-an-update-msg");
              this.sendQuotation();
              this.message = "";
              return;
            }
            if (this.status == 9 && !this.isCustomer) {
              this.loadChart();

              this.$emit("RequestAnUpdateEvent");
              this.$bvModal.hide("request-an-update-msg");
              this.message = "";
              this.handUpdatePricing();
              return;
            }
            this.$bvModal.hide("request-an-update-msg");
            this.$emit("RequestAnUpdateEvent");

            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Send Request An Update success!",
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
            this.loadChart();

            this.message = "";
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Send Request An Update error!",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          });
      }
    },
    acceptQuotation() {
      useJwt
        .put("wr1?objectType=AcceptQuotation", {
          id: this.request_quotation.id,
        })
        .then((response) => {
          this.$emit("acceptQuotationEvent");

          this.$swal({
            icon: "success",
            title: "Accept Quotation success!",
            showConfirmButton: false,
            timer: 1500,
          });

          this.$router.push({ name: "user-my-booking" });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Accept Quotation error!",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    },
    async sendQuotation() {
      var validate = await this.$refs.quotationRules
        .validate()
        .then((success) => {
          return success;
        });
      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("notifyFormError"),
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }
      let t = 0;
      this.currencies.forEach((e) => {
        t += this.getTotal(e.id);
      });
      if (t == 0 || Number.isNaN(t)) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Total = 0, please enter at least one fee!",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }
      this.quotation.costs = this.costs;
      this.quotation.pricing = this.pricing;
      let service =
        this.view_quotation != null
          ? "EditQuotationOfBooking"
          : "CreateQuotationOfBooking";
      useJwt
        .put("wr1?objectType=" + service, this.quotation)
        .then((response) => {
          this.$bvModal.hide("modal-approve");
          this.$emit("loadMyQuotation", []);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("quotationSendSuccess"),
              icon: "CheckSquareIcon",
              variant: "primary",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("quotationSendError"),
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    },

    FN: function (value) {
      try {
        return (value + "")
          .replace(/[^0-9]/g, "")
          .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
      } catch (err) {
        return value;
      }
    },
    FNVN: function (value) {
      try {
        if (Number(value)) {
          return this.$Utils.formatMooney(
            value.replace(/\./g, "").replace(/,/g, ""),
            "vi-VN"
          );
        }
      } catch (err) {
        return value;
      }
    },
    FNUS: function (value) {
      try {
        if (Number(value)) {
          return this.$Utils.formatMooney(value.replace(/,/g, ""), "en-US");
        }
      } catch (err) {
        return value;
      }
    },
    vdropzoneError(file, errorMessage) {
      this.$refs.acceptBookingFile.removeFile(file);
      if (errorMessage.includes("Max filesize: 10MiB")) {
        return this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("uploadSizeErrorFile"),
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }

      if (errorMessage.includes("You can not upload any more files.")) {
        return this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("uploadLimitErrorFile"),
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    },
  },
};
</script>
<style lang="scss">
@import "~@core/scss/base/pages/app-chat.scss";
@import "~@core/scss/base/pages/app-chat-list.scss";
.mybooking-online-cost {
  & .custom_check_quote {
    padding: 0;
    margin-bottom: 1.5rem;
    margin-left: 1rem;
  }
  & .tb-dropdown .select3-selection .input-selection {
    border: none;
  }
  & .form-control {
    border: none;
  }
  & .select2-container--default .select2-selection--single {
    border: none;
  }
  & .custom-right {
    display: flex;
    justify-content: end;
  }
  & .text-warning-blue {
    color: #2b938c;
    font-size: 2rem;
  }
}
</style>
